import { motion } from 'framer-motion'
import { memo } from 'react'

const UpAndDownThreeDots = memo(() => {
  return (
    <div className="flex flex-gap-x-2">
      {[1, 2, 3].map(dot => (
        <motion.div
          key={dot}
          className="w-2 h-2 bg-primary-600 dark:bg-primary-100 rounded-full"
          animate={{
            y: [0, -8, 0], // 위아래로 움직이는 효과 추가
            scale: [1, 1.3, 1],
            opacity: [1, 0.5, 1],
          }}
          transition={{
            duration: 1,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: (dot - 1) * 0.2,
          }}
        />
      ))}
    </div>
  )
})

UpAndDownThreeDots.displayName = 'UpAndDownThreeDots'

export default UpAndDownThreeDots
